import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const DisclaimerPage = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "免責事項 | TOUAREG GLOBAL",
      "description": "株式会社ミションの免責事項。投資・資産管理サービスに関するリスクと免責について詳しく説明しています。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/disclaimer`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "TOUAREG GLOBAL",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      },
      "publisher": {
        "@type": "Organization",
        "name": "株式会社ミション"
      },
      "dateModified": "2025-01-01",
      "inLanguage": "ja"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              免責事項
            </h1>
            
            <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
              <div>
                <p className="text-gray-600 mb-6">
                  株式会社ミション（以下「当社」といいます。）が提供する投資・資産管理サービスおよび本ウェブサイトに関する免責事項について、以下のとおり定めます。本サービスをご利用になる前に、必ずお読みください。
                </p>
              </div>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. 投資リスクに関する免責</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 投資には元本割れのリスクがあります。当社が提供する投資助言やコンサルティングサービスは、将来の運用成果を保証するものではありません。</p>
                  <p>2. プライベートエクイティ投資は、特に高いリスクを伴う投資商品です。投資判断は、お客様ご自身の責任において行っていただく必要があります。</p>
                  <p>3. 市場の変動、経済情勢の変化、投資先企業の業績悪化等により、投資元本を下回る可能性があります。</p>
                  <p>4. 当社は、投資による損失について一切の責任を負いません。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. 情報の正確性に関する免責</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 本ウェブサイトに掲載されている情報は、作成時点での情報に基づいており、その正確性、完全性、最新性を保証するものではありません。</p>
                  <p>2. 当社は、本ウェブサイトの情報に基づいて行われた投資判断により生じた損害について、一切の責任を負いません。</p>
                  <p>3. 投資に関する最終的な判断は、必ずお客様ご自身で行っていただくようお願いいたします。</p>
                  <p>4. 当社は、予告なく本ウェブサイトの内容を変更または削除する場合があります。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. 第三者情報に関する免責</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 本ウェブサイトには、第三者が提供する情報や第三者のウェブサイトへのリンクが含まれる場合があります。</p>
                  <p>2. これらの第三者情報の正確性、信頼性について、当社は一切保証いたしません。</p>
                  <p>3. 第三者のウェブサイトの利用により生じた損害について、当社は責任を負いません。</p>
                  <p>4. 第三者のウェブサイトのプライバシーポリシーや利用規約については、各サイトの規定に従ってください。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. システム・技術的事項に関する免責</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 当社は、本ウェブサイトの動作について、中断、遅延、停止がないことを保証するものではありません。</p>
                  <p>2. システムメンテナンス、サーバー障害、通信回線の障害等により、本ウェブサイトが利用できない場合があります。</p>
                  <p>3. コンピューターウイルス、不正アクセス等による被害について、当社は責任を負いません。</p>
                  <p>4. お客様のコンピューター環境により、本ウェブサイトが正常に表示されない場合があります。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. 法的規制に関する免責</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 投資助言業務は、金融商品取引法等の関連法令に基づいて行われます。</p>
                  <p>2. 法令の改正、規制の変更等により、サービス内容が変更される場合があります。</p>
                  <p>3. 当社は、法令遵守のため、お客様との取引をお断りする場合があります。</p>
                  <p>4. 税務上の取扱いについては、税理士等の専門家にご相談ください。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. 損害賠償の制限</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 当社の故意または重大な過失による場合を除き、当社は本サービスに関連して生じた損害について責任を負いません。</p>
                  <p>2. 当社が責任を負う場合であっても、その損害賠償額は、お客様が当社に支払った手数料の範囲内とします。</p>
                  <p>3. 間接損害、特別損害、逸失利益等については、当社は責任を負いません。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. 知的財産権</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 本ウェブサイトに掲載されている文章、画像、動画等のコンテンツの著作権は、当社または正当な権利者に帰属します。</p>
                  <p>2. これらのコンテンツを無断で複製、転載、配布することは禁止されています。</p>
                  <p>3. 商標、ロゴ等の知的財産権の侵害行為は固く禁じられています。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. 適用法令・管轄裁判所</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 本免責事項は、日本法に準拠し、日本法に従って解釈されます。</p>
                  <p>2. 本サービスに関する紛争については、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. 免責事項の変更</h2>
                <div className="text-gray-600 leading-relaxed space-y-3">
                  <p>1. 当社は、必要に応じて本免責事項を変更することがあります。</p>
                  <p>2. 変更後の免責事項は、本ウェブサイトに掲載した時点から効力を生じます。</p>
                  <p>3. 重要な変更については、事前にお客様に通知いたします。</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. お問い合わせ</h2>
                <div className="text-gray-600 leading-relaxed">
                  <p className="mb-4">
                    本免責事項に関するご質問やお問い合わせは、下記までご連絡ください。
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="font-semibold text-gray-900 mb-3">株式会社ミション</h3>
                    <div className="space-y-2">
                      <p><strong>所在地：</strong>〒610-0121 京都府城陽市寺田北山田26-7-401</p>
                      <p><strong>電話番号：</strong>090-3677-1000</p>
                      <p><strong>メールアドレス：</strong>touaregglobal@gmail.com</p>
                      <p><strong>受付時間：</strong>平日 9:00-18:00</p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <div className="text-center pt-8 border-t border-gray-200">
                  <p className="text-gray-600">
                    制定日：2025年1月1日<br />
                    最終更新日：2025年1月1日
                  </p>
                  <p className="text-gray-900 font-semibold mt-4">
                    株式会社ミション<br />
                    代表取締役 福井秀延
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DisclaimerPage;